/**
 * "Check the site" (trust fix, 2026-10-29; server: services/woSiteCheck.ts).
 *
 * A work order whose store intake matched at low confidence (or not at all)
 * is held from dispatch until someone in the office says the site is right.
 * The server answers 409 SITE_CHECK_REQUIRED on assign / schedule; the pick
 * itself (job page, Work orders waiting) carries the "Site is right" button.
 */
import { toast } from "sonner";

import { api } from "@/lib/api";

export const SITE_CHECK_REQUIRED = "SITE_CHECK_REQUIRED";

export interface SiteCheck {
    jobId: string;
    displayNumber: string | null;
    customer: string | null;
    woNumber: string | null;
    /** The service location printed on the work order. */
    woSays: string | null;
    /** The site the job is on now. */
    jobSite: string | null;
    /** true = intake found no store at all. */
    unmatched: boolean;
    intakeItemId: string;
}

export function isSiteCheckRequired(code: string | undefined | null): boolean {
    return code === SITE_CHECK_REQUIRED;
}

/** Where "Check the work order" goes: the intake item's review screen. */
export function siteCheckReviewHref(c: Pick<SiteCheck, "intakeItemId">): string {
    return `/jobs/work-orders/review/${c.intakeItemId}`;
}

export function confirmSite(jobId: string): Promise<unknown> {
    return api.post(`/api/jobs/${jobId}/site-confirmed`, {});
}

/** The Grid's answer to a 409: say why, one button to the job (where the pick is). */
export function siteCheckToast(message: string | undefined, openJob: () => void): void {
    toast.warning(message ?? "Check the site first. The work order's address didn't clearly match this store.", {
        action: { label: "Open job", onClick: openJob },
    });
}
